import { useEffect, useState } from "react";
import { BarChart3 } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

const Stat = ({ label, value, testid }) => (
  <div className="rounded-lg bg-black/30 border border-white/10 px-3 py-2">
    <div className="text-[10px] uppercase tracking-wide text-slate-500">{label}</div>
    <div className="font-display text-xl text-white" data-testid={testid}>{value}</div>
  </div>
);

export const PromoStats = ({ code }) => {
  const { t, lang } = useI18n();
  const [s, setS] = useState(null);
  useEffect(() => { api.get(`/admin/promos/${code}/stats`).then((r) => setS(r.data)).catch(() => setS({ error: true })); }, [code]);
  if (!s) return <div className="text-xs text-slate-500 w-full" data-testid={`promo-stats-loading-${code}`}>…</div>;
  if (s.error) return null;
  return (
    <div className="w-full mt-2 space-y-3" data-testid={`promo-stats-${code}`}>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
        <Stat label={t("adm.ps_users")} value={s.users} testid={`promo-stats-users-${code}`} />
        <Stat label={t("adm.ps_active")} value={s.active} testid={`promo-stats-active-${code}`} />
        <Stat label={t("adm.ps_clips")} value={s.clips} testid={`promo-stats-clips-${code}`} />
        <Stat label={t("adm.ps_buyers")} value={s.buyers} testid={`promo-stats-buyers-${code}`} />
        <Stat label={t("adm.ps_revenue")} value={`${s.revenue.toFixed(2)} $`} testid={`promo-stats-revenue-${code}`} />
      </div>
      {s.top.length > 0 ? (
        <div className="rounded-lg border border-white/10 divide-y divide-white/5 max-h-64 overflow-auto">
          {s.top.map((u, i) => (
            <div key={i} className="flex items-center gap-3 px-3 py-2 text-xs" data-testid={`promo-stats-user-${i}`}>
              <span className="text-white font-semibold truncate">{u.name}</span>
              <span className="text-slate-500 truncate hidden sm:inline">{u.email}</span>
              <span className="text-slate-500 ml-auto">{new Date(u.at).toLocaleDateString(lang === "fr" ? "fr-CA" : "en-CA")}</span>
              <span className="text-[#22e3a1] font-mono w-20 text-right">{t("adm.ps_n_clips").replace("{n}", u.clips)}</span>
              {u.paid > 0 && <span className="text-[#ffc94d] font-mono">💳 {u.paid}</span>}
            </div>
          ))}
        </div>
      ) : <p className="text-xs text-slate-500" data-testid={`promo-stats-empty-${code}`}>{t("adm.ps_empty")}</p>}
    </div>
  );
};

export const PromoStatsButton = ({ open, onClick, code }) => (
  <button onClick={onClick} aria-pressed={open} className={`cx-metal rounded-lg p-2 ${open ? "cx-metal-active" : ""}`} data-testid={`promo-stats-btn-${code}`}><BarChart3 className="w-4 h-4" /></button>
);
